import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const indoorPlay3YearsOld: BlogMetaData = {
  title: '3歳児の室内遊び15選｜家でできるゲーム・運動・ごっこ遊びとモンテッソーリ流の選び方',
  description:
    '3歳児の室内遊びを、ルールのあるゲーム・運動遊び・ごっこ遊び・製作から家でできる15種類厳選。発達に合う遊びの選び方3基準、雨の日の組み合わせ、飽きるときの対応までモンテッソーリ流に解説します。',
  thumbnailUrl: '/img/blog-indoor-play-3-years-old.webp',
  filePath: buildBlogFilePath('indoor-play-3-years-old'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
